import { IBaseAction } from "../Actions/BaseAction";
import { IMapMarker } from "../Models/IMapMarker";

export type SingleMarkerMapState = {
    marker: IMapMarker;
    zoom: number;
};

export type SetMapJsApiLoadedAction = IBaseAction<boolean>;
export type SetMapMarkersAction = IBaseAction<IMapMarker[]>;
export type SetMapCenterAction = IBaseAction<google.maps.LatLng>;
export type SetMapZoomAction = IBaseAction<number>;
export type SetLoadingOverlay = IBaseAction<boolean>;

export type MapActionType =
    SetMapJsApiLoadedAction |
    SetMapMarkersAction |
    SetMapCenterAction |
    SetLoadingOverlay|
    SetMapZoomAction;

export const SET_MAP_JS_API_LOADED = "SET_MAP_JS_API_LOADED";
export const SET_MAP_MARKERS_NEW = "SET_MAP_MARKERS_NEW";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const SET_MAP_ZOOM = "SET_MAP_ZOOM";
export const SET_LOADING_OVERLAY = "SET_LOADING_OVERLAY";
